// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cd8b0fc3","667":"43ab1b66","977":"93946680"}[chunkId] + ".chunk.js";
};